import { onMounted, readonly, ref, useEventListener } from '#imports'

/**
 * Whether the window has fired its load event. False on the server and during the first
 * client render, so SSR markup and hydration match; true once load fires, or from mount if
 * it already has. Use it to start work that must not compete with the initial page load.
 */
export function usePageLoaded() {
    const loaded = ref(false)

    if (import.meta.client) {
        useEventListener(window, 'load', () => {
            loaded.value = true
        }, { once: true })

        onMounted(() => {
            if (document.readyState === 'complete') loaded.value = true
        })
    }

    return readonly(loaded)
}
